import { z } from "zod";

export const PostalAddressValidationSchema = z.object({
  address: z.string().min(1, "Adresse ist zu kurz"),
  zipCode: z.string().min(1, "PLZ ist zu kurz"),
  city: z.string().min(1, "Stadt ist zu kurz"),
  country: z.string().min(1, "Land ist zu kurz"),
});
